<template>
<!-- 清单视图 -->
<div class="window" style="width: 100%">
    <div class="nav">
      <div class="nav-lt">
        <img
          class="nav-lt-img"
          src="../../assets/img/home/center/whole.png"
          alt=""
          @click="displayleft"
        />
        <div class="nav-lt-tit">清单视图</div>
      </div>
      <div class="nav-rt">
        <el-switch
          class="nav-rt-sw"
          v-model="switchVal"
          :width="33"
          active-color="#13ce66"
          inactive-color="#bbbbbc"
          @change="switchChang"
        >
        </el-switch>
        <div class="nav-rt-txt">显示已完成</div>
      </div>
    </div>
</div>
</template>>

<script>
export default {
  components: {
    leftNav,
  },
}
</script>>